import * as types from './mutation-types'

export const fetchDynamicTemplates = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    // If Zoho redirected with ?code=..., include it once, then clean URL to avoid loops
    const url = new URL(window.location.href)
    const codeFromUrl = url.searchParams.get('code')
    const mergedParams = Object.assign({}, params || {})
    if (codeFromUrl && !mergedParams.code) {
      mergedParams.code = codeFromUrl
    }

    window.axios.get(`/api/super/admin/dynamic-templates`, { params: mergedParams, headers: { 'Accept': 'application/json' } }).then((response) => {
      if (response.data.success === true) {
        const payload = response.data && response.data.data
        const list = payload && Array.isArray(payload.templates) ? payload.templates : []
        const normalized = list.map(t => ({
          ...t,
          name: t && t.email_action ? t.email_action.name : '',
          action: t && t.email_action ? t.email_action.action_identifier : ''
        }))
        commit(types.BOOTSTRAP_TEMPLATES, normalized)
      }
      // Remove code param from URL after successful call to prevent re-processing
      if (codeFromUrl) {
        url.searchParams.delete('code')
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, url.pathname + (url.search ? `?${url.searchParams.toString()}` : '') + url.hash)
        }
      }
      resolve(response)
    }).catch((err) => {
      const res = err && err.response
      if (res && res.status === 409 && res.data && res.data.redirect_to) {
        // Navigate in the same tab to complete OAuth
        window.location.assign(res.data.redirect_to)
        // Resolve to prevent unhandled promise rejection before navigation
        return resolve({ redirected: true })
      }
      reject(err)
    })
  })
}

export const addEmailTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    const payload = {
      template_name: data.name,
      subject: data.subject || data.name,
      htmlbody: data.html_content || data.htmlbody || '<html><body><p></p></body></html>',
      template_alias: data.template_alias || (data.action_id ? `action-${data.action_id}` : undefined),
      action_id: data.action_id
    }
    window.axios.post('/api/super/admin/dynamic-templates', payload).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const fetchEmailTemplate = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/dynamic-templates/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateEmailTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    const payload = {
      template_name: data.template_name || data.name,
      subject: data.subject || data.name,
      htmlbody: data.html_content || data.htmlbody,
      template_alias: data.template_alias
    }
    window.axios.put(`/api/super/admin/dynamic-templates/${data.id}`, payload).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteEmailTemplate = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete(`/api/super/admin/dynamic-templates/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const changeStatusCommunication = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/communications/${id}/statusChange`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const selectAllCommunications = ({ commit, dispatch, state }) => {
  if (state.selectedCommunications.length === state.communications.length) {
    commit(types.SET_SELECTED_COMMUNICATIONS, [])
    commit(types.SET_SELECT_ALL_STATE, false)
  } else {
    let allCommunicationIds = state.communications.map(cust => cust.id)
    commit(types.SET_SELECTED_COMMUNICATIONS, allCommunicationIds)
    commit(types.SET_SELECT_ALL_STATE, true)
  }
}
export const selectCommunication = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_COMMUNICATIONS, data)
  if (state.selectedCommunications.length === state.communications.length) {
    commit(types.SET_SELECT_ALL_STATE, true)
  } else {
    commit(types.SET_SELECT_ALL_STATE, false)
  }
}
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data)
}
